import { useTranslation } from 'react-i18next';
import { History, X } from 'lucide-react';
import type { TFunction } from 'i18next';
import { filtryZWpisu, podpisWpisu, type WpisHistorii } from '@/lib/historiaWyszukiwan';

/**
 * Lista ostatnich wyszukiwań — ta sama w nakładce obszaru (dotyk) i w liście pod polem
 * obszaru (pulpit z myszą). Wiersz = podpis wpisu („Mokotów · 2 pokoje · do 4 000 zł z
 * opłatami"), pod nim „+N filtry"; każdy ma „×", na końcu „Wyczyść historię". Stan trzyma
 * rodzic (odczyt z `localStorage`), tu jest tylko rysowanie.
 */
export function HistoriaWyszukiwan({
  wpisy,
  naWybierz,
  naUsun,
  naWyczysc,
  zwarta = false,
}: {
  wpisy: WpisHistorii[];
  naWybierz: (w: WpisHistorii) => void;
  naUsun: (q: string) => void;
  naWyczysc: () => void;
  /** Lista pod polem na pulpicie — mniejszy krój i odstępy niż w nakładce na telefonie. */
  zwarta?: boolean;
}) {
  const { t, i18n } = useTranslation();
  if (wpisy.length === 0) return null;
  return (
    <div data-testid="historia-wyszukiwan">
      <ul>
        {wpisy.map((w) => {
          const { glowny, reszta } = podpisWpisu(filtryZWpisu(w), t as TFunction, i18n.language);
          return (
            <li key={w.q} className="flex items-center">
              <button
                type="button"
                onClick={() => naWybierz(w)}
                data-testid="wpis-historii"
                className={`flex min-w-0 flex-1 items-center gap-3 text-left hover:bg-muted ${zwarta ? 'px-3 py-2' : 'px-4 py-3'}`}
              >
                <History className="h-4 w-4 shrink-0 text-muted-foreground" />
                <span className="min-w-0">
                  {/* Dwie linie zamiast ucinania: „do 4 000 zł z o…" na telefonie gubiło tryb ceny,
                      czyli połowę tego, co odróżnia wpisy od siebie. */}
                  <span className={`line-clamp-2 block ${zwarta ? 'text-sm' : 'text-base'}`}>{glowny}</span>
                  {reszta > 0 && (
                    <span className="block text-xs text-muted-foreground">
                      {t('search.history.more_filters', { count: reszta })}
                    </span>
                  )}
                </span>
              </button>
              <button
                type="button"
                onClick={() => naUsun(w.q)}
                aria-label={t('search.history.remove', { name: glowny })}
                className="flex h-11 w-11 shrink-0 items-center justify-center text-muted-foreground hover:text-foreground"
              >
                <X className="h-4 w-4" />
              </button>
            </li>
          );
        })}
      </ul>
      <button
        type="button"
        onClick={naWyczysc}
        data-testid="wyczysc-historie"
        className={`w-full text-left text-xs font-semibold text-primary hover:underline ${zwarta ? 'px-3 py-2' : 'px-4 py-3'}`}
      >
        {t('search.history.clear_all')}
      </button>
    </div>
  );
}

export default HistoriaWyszukiwan;
